<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                id="115">
                    <h2>रिपोर्टस  </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='31'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="115">
                    <label for="">रिपोर्टें भुगतान गेटवे के माध्यम से संसाधित विभिन्न वित्तीय और लेनदेन संबंधी गतिविधियों का विस्तृत सारांश या विश्लेषण हैं। ये रिपोर्टें व्यापारियों को मूल्यवान अंतर्दृष्टि और जानकारी प्रदान करती हैं जिससे उन्हें अपने वित्तीय लेनदेन की प्रभावी ढंग से निगरानी, विश्लेषण और प्रबंधन करने में मदद मिलती है।
                    </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="116">
                    <h2>
                        रिपोर्ट का प्रकार 
                    </h2>
                    <h3 class="col-md-12 mt-4">
                        शुल्क रिपोर्ट
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp; शुल्क रिपोर्ट भुगतान गेटवे के माध्यम से संसाधित लेनदेन से जुड़ी फीस का विस्तृत विवरण प्रदान करती है। 

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp;व्यापारियों को प्रत्येक लेनदेन में शामिल लागतों को समझने और उनका विश्लेषण करने में सक्षम बनाता है, जिससे बेहतर वित्तीय योजना और निर्णय लेने में सुविधा होती है। 

                    </label>
                    <h3 class="col-md-12 mt-4">
                        स्नैपशॉट  
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp; स्नैपशॉट प्रमुख प्रदर्शन संकेतकों का एक संक्षिप्त अवलोकन है, जो भुगतान गेटवे की गतिविधि और स्वास्थ्य की वास्तविक समय की झलक देता है।  
                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp; व्यापारियों को अपने लेनदेन की वर्तमान स्थिति का आकलन करने का एक त्वरित और आसान तरीका प्रदान करता है, जिससे उन्हें सूचित और उत्तरदायी रहने में मदद मिलती है। 
                    </label>
                    
                    <h3 class="col-md-12 mt-4">
                        व्यापारी का वक्तव्य   
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp;मर्चेंट स्टेटमेंट एक व्यापक रिपोर्ट है जिसमें एक विशिष्ट अवधि के भीतर सभी लेनदेन, शुल्क और अन्य प्रासंगिक वित्तीय जानकारी का विवरण दिया गया है। 

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp; लेखांकन उद्देश्यों के लिए आवश्यक, व्यापारियों को उनके वित्तीय रिकॉर्ड को समेटने और सटीक वित्तीय विवरण बनाए रखने में सहायता करना।   

                    </label>
                    <h3 class="col-md-12 mt-4">
                        लेन-देन सारांश रिपोर्ट  
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp;  लेन-देन सारांश रिपोर्ट भुगतान गेटवे के माध्यम से संसाधित सभी लेन-देन का एक सारांश दृश्य प्रदान करती है, जिसमें सफल और असफल लेन-देन भी शामिल हैं।  

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp;व्यापारियों को लेनदेन के रुझानों पर नज़र रखने और उनका विश्लेषण करने, संभावित मुद्दों की पहचान करने और उनकी भुगतान प्रक्रियाओं को अनुकूलित करने में सहायता करता है। 

                    </label>
                    <h3 class="col-md-12 mt-4">
                        त्वरित कोड लेनदेन सारांश  
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp; यह रिपोर्ट विशेष रूप से त्वरित कोड का उपयोग करके किए गए लेनदेन का सारांश प्रस्तुत करती है, जो इस विशेष लेनदेन पद्धति का एक केंद्रित अवलोकन प्रस्तुत करती है। 

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp;त्वरित कोड के माध्यम से किए गए लेनदेन के प्रदर्शन और दक्षता में अंतर्दृष्टि प्रदान करता है, जिससे व्यापारियों को इस भुगतान विकल्प को अनुकूलित करने में सहायता मिलती है।   

                    </label>
                    <h3 class="col-md-12 mt-4">
                        वेबहुक डेटा 
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp;वेबहुक डेटा रिपोर्ट में वेबहुक के माध्यम से भुगतान गेटवे और बाहरी अनुप्रयोगों के बीच डेटा आदान-प्रदान के बारे में जानकारी शामिल है।  

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp; डेवलपर्स और सिस्टम इंटीग्रेटर्स के लिए महत्वपूर्ण, बेहतर सिस्टम विश्वसनीयता के लिए वेबहुक इंटरैक्शन की निगरानी और डिबगिंग की सुविधा प्रदान करना।  

                    </label>

                    <h3 class="col-md-12 mt-4">
                        सुलह रिपोर्ट 
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp; सुलह रिपोर्ट सटीकता सुनिश्चित करते हुए व्यापारियों को भुगतान गेटवे के माध्यम से संसाधित लेनदेन के साथ उनके आंतरिक रिकॉर्ड का मिलान करने में मदद करती है।  

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp;वित्तीय रिकॉर्ड में त्रुटियों और विसंगतियों को कम करते हुए, समाधान प्रक्रिया को सरल बनाता है। 

                    </label>

                    <h3 class="col-md-12 mt-4">
                        आदेश विफलता   
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp;ऑर्डर विफलता रिपोर्ट उन लेनदेन को उजागर करती है जो सफलतापूर्वक नहीं हुए, विफलता के कारणों के बारे में विवरण प्रदान करते हैं। 

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp;व्यापारियों को समस्याओं को तुरंत पहचानने और उनका समाधान करने में सक्षम बनाता है, जिससे लेनदेन विफलताओं के कारण राजस्व हानि की संभावना कम हो जाती है।  

                    </label>

                    <h3 class="col-md-12 mt-4">
                        भुगतान विफलता  
                    </h3>
                    <label for="" class="mt-3"><b> विवरण:</b> &nbsp;पेआउट विफलता रिपोर्ट उन उदाहरणों का विवरण देती है जहां व्यापारियों को निर्धारित भुगतान असफल रहे थे।  

                    </label>
                    <label for="" class="mt-3"><b>लाभ:  </b> &nbsp;  व्यापारियों को भुगतान संबंधी समस्याओं का तुरंत समाधान करने की अनुमति देता है, जिससे एक सुचारू और विश्वसनीय भुगतान प्रक्रिया सुनिश्चित होती है। 

                    </label>
                    <div class="col-md-12 mt-4">
                        <label for="">संक्षेप में, ये रिपोर्टें व्यापारियों के लिए पारदर्शिता, जवाबदेही और कार्रवाई योग्य अंतर्दृष्टि प्रदान करने में महत्वपूर्ण भूमिका निभाती हैं, जो अंततः उनके व्यवसायों के कुशल और सफल संचालन में योगदान देती हैं। </label>
                    </div>



                    

                </div>
                
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची :
                    </h5>

                </div>

                <!-- <div class="col-md-12 mt-2">
                    <a href="#31"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10"><span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Refunds </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-2">
                    <a href="#115">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10"><span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')">
                                    रिपोर्ट क्या हैं?    </span>

                            </div>

                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#116">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">रिपोर्ट का प्रकार 
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/settlement']">     <button class="btn btn-color" (click)="menues('Settlement')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;सेटलमेंट 
                </button></a>
               
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/merchant-dashboard']"> <button class="btn btn-color" (click)="menues('Merchant')" >मर्चेंट डैशबोर्ड 
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
                
            </div>
        </div>
    </div>
</div>